<ng-container *transloco="let t;">
  <form (submit)="onSubmit()" novalidate>

      <div class="p-grid">
        <div class="p-col-6">
          <h2>{{ t('common.labels.basedata') }}</h2>
        </div>
        <div class="p-col-6 p-text-right">
          <app-form-buttons [submitting]="submitting" (cancelled)="onCancel()"></app-form-buttons>
        </div>
      </div>

      <div class="p-grid p-fluid">
        <div class="p-col-12">
          <app-form-control [cid]="'active'" [control]="form.get('active')" [type]="'checkbox'" [label]="t('common.labels.active')"></app-form-control>
          <app-form-control [cid]="'title'" [control]="form.get('title')" [type]="'input'" [label]="t('common.labels.title')"></app-form-control>
          <app-form-control [cid]="'description'" [control]="form.get('description')" [type]="'textarea'" [label]="t('common.labels.description')"></app-form-control>
        </div>
      </div>

      <hr />

      <app-messageorder-settings #settings [form]="form" [options]="options"></app-messageorder-settings>

  </form>
</ng-container>
